module.exports = __webpack_public_path__ + "media/images/vouchers/exp_duo-9c1b4750f7d6d33a554abc17b530591a.png";